export default __webpack_public_path__ + "static/media/puutarha_2.a2d2987b.jpg";